import { VerificationRequestActionType, gql } from "types";
import { useSafeMutation } from "./useSafeMutation";

const SEND_EMAIL_OTP_MUTATION = gql(/* GraphQL */ `
  mutation SendOtpViaEmail($actionType: VerificationRequestActionType!) {
    sendOtpViaEmail(actionType: $actionType) {
      id
      actionType
      createdAt
    }
  }
`);

export const useSendEmailOtp = () => {
  const [sendOtpViaEmail, { loading, error }] = useSafeMutation(
    SEND_EMAIL_OTP_MUTATION,
  );

  const sendEmailOtp = async (actionType: VerificationRequestActionType) => {
    const result = await sendOtpViaEmail({
      variables: { actionType },
    });
    const createdAt = result.data?.sendOtpViaEmail?.createdAt;
    return {
      ...result.data?.sendOtpViaEmail,
      createdAt: createdAt ? new Date(createdAt) : undefined,
    };
  };

  return { sendEmailOtp, loading, error };
};
